import axios from "axios";

import { BASE_URL, LOGIN_URL } from './common';

export const REGISTER_URL = "api/auth/register";
export const REQUEST_PASSWORD_URL = "api/auth/forgot-password";


export function getInOutsList() {
  var url = BASE_URL + 'user?pageSize=10000';
  return axios.get(url);
}

export function registerUser(deptId,
  email,
  endDt,
  nm,
  phone,
  positionId,
  startDt,
  typeId,
  userNo) {

  var params = {
    deptId,
    email,
    endDt,
    nm,
    phone,
    positionId,
    startDt,
    typeId,
    userNo
  }

console.log(params)

  var paramStr = Object.keys(params).map(key => `${key}=${encodeURIComponent(params[key])}`).join('&');
  var url = BASE_URL + 'user?' + paramStr;
  return axios.post(url, params);
}

export function detectFace(image) {

  var img = image.split(',');
  var _image = img.length > 1 ? img[1] : image

  var params = { image: _image }

  var url = BASE_URL + 'face/detection'
  return axios.post(url, params);
}

export function registerFace(userId, image) {

  var img = image.split(',');
  var _image = img.length > 1 ? img[1] : image

  var params = {
    userId,
    image: _image
  }

  var url = BASE_URL + 'face?userId=' + userId;

  return axios.post(url, params);
}

export function registerCard(userId, 
                              cardNo, 
                              cardStatus,
                              descs,
                              endDt,
                              startDt) {
  var params = {      
    cardNo, 
    cardStatus,
    descs,
    endDt,
    startDt, 
    userId
  }

  var paramStr = Object.keys(params).map(key => `${key}=${encodeURIComponent(params[key])}`).join('&');
  var url = BASE_URL + 'card?' + paramStr;

  return axios.post(url, params);
}

export function checkExistCard(userId, cardNo) {

  var url = BASE_URL + `card/exist/${cardNo}`
  return axios.get(url);
}

export function registerAccess(userId, accessGrpIds) {

  var params = {
    userId, accessGrpIds
  }

  var paramStr = Object.keys(params).map(key => `${key}=${encodeURIComponent(params[key])}`).join('&');
  var url = BASE_URL + `user/${userId}/accessGrp?${paramStr}`;
  return axios.put(url, params);
}

export function getUserTypeList() {
  var url = BASE_URL + 'usertype?pageSize=10000';
  return axios.get(url);
}

export function getPositionList() {
  var url = BASE_URL + 'position?pageSize=10000';
  return axios.get(url);
}

export function getDeptList() {
  var url = BASE_URL + 'dept?pageSize=10000';
  return axios.get(url);
}

export function getFaceList() {
  var url = BASE_URL + 'face?pageSize=10000';
  return axios.get(url);
}

export function getCardList() {
  var url = BASE_URL + 'card?pageSize=10000';
  return axios.get(url);
}

export function getAccessList() {
  var url = BASE_URL + 'accessgrp?pageSize=10000';
  return axios.get(url);
}

